export function formatKoreanNumber(num: number): string {
  if (!num) {
    return '0';
  }
  return Number(num)?.toLocaleString('ko-KR');
}
